var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransformRotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4867 7.99967C15.4867 11.6797 12.5 14.6663 8.81999 14.6663C5.13999 14.6663 2.89332 10.9597 2.89332 10.9597M2.89332 10.9597H5.90665M2.89332 10.9597V14.293M2.15332 7.99967C2.15332 4.31967 5.11332 1.33301 8.81999 1.33301C13.2667 1.33301 15.4867 5.03967 15.4867 5.03967M15.4867 5.03967V1.70634M15.4867 5.03967H12.5267",
    stroke: "#464953",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransformRotation);
export default __webpack_public_path__ + "static/media/transform_rotation.24292f69b98f1b68b8312a18dbea60c3.svg";
export { ForwardRef as ReactComponent };